<template>
  <div class="header-breadcrumbs-mobile-320 screen">
    <BreadCrumbs :player="player" />
    <header class="header-1">
      <div class="header_container-1">
        <div class="player_data-1">
          <PhotoClub :foto_Jugador="player.player_photo" :foto_Equipo="player.team_logo" v-if="player.player_photo" />
          <div class="info-1">
            <div class="info_container-1" v-if="player.player_photo">
              <Name :player="player" />
              <div class="container_info-1">
                <div class="nationality-age-3">
                  <img class="country-flag-3" :src="player.flag" alt="country-flag" />
                  <div class="nationality-age-item-3 valign-text-middle avenirnextltpro-demi-normal-white-10px">
                    {{ playerNationality }}
                  </div>
                  <div class="nationality-age-item-3 valign-text-middle avenirnextltpro-light-white-10px">
                    |
                  </div>
                  <div class="nationality-age-item-3 valign-text-middle avenirnextltpro-demi-normal-white-10px">
                    {{ player.dob | toAge }} {{ $t('player.years_old') }}
                  </div>
                </div>
                <div class="btn_player_info" @click="openModal">
                  <div class="player-info valign-text-middle">Player Info</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header_info_menu-1 avenirnextltpro-demi-normal-white-6px">
          <div class="btn-1" :class="value === 4 ? 'active' : ''" @click="onChangeSection(4)">
            <div class="defensivo-1 valign-text-middle">RESUMEN</div>
          </div>
          <div class="btn-1" :class="value === 1 ? 'active' : ''" @click="onChangeSection(1)">
            <div class="defensivo-1 valign-text-middle">POSESIÓN</div>
          </div>
          <div class="btn-1" :class="value === 2 ? 'active' : ''" @click="onChangeSection(2)">
            <div class="defensivo-1 valign-text-middle">OFENSIVO</div>
          </div>
          <div class="btn-1" :class="value === 3 ? 'active' : ''" @click="onChangeSection(3)">
            <div class="defensivo-1 valign-text-middle">DEFENSIVO</div>
          </div>
        </div>
      </div>
    </header>
    <ModalPlayerInfo :show="showModal" @close="closeModal" :player="player" />
  </div>
</template>
<script>
import ModalPlayerInfo from '@/components/Modals/ModalPlayerInfo';
import playerHeaderMixin from '@/utils/mixins/player-header';
import BreadCrumbs from '@/components/Sections/HeaderFigma/BreadCrumbs';
import PhotoClub from '@/components/Sections/HeaderFigma/PhotoClub';
import Name from '@/components/Sections/HeaderFigma/Name';
export default {
  name: 'HeaderBreadcrumbsMobile320',
  components: {
    BreadCrumbs,
    PhotoClub,
    Name,
    ModalPlayerInfo,
  },
  props: {
    player: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      section: 4,
      showModal: false,
      sections: [
        {
          id: 4,
          title: 'analysis_type.summary',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen_unselected.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen.svg',
          ],
          selected: false,
        },
        {
          id: 1,
          title: 'analysis_type.possession',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-white.svg',
          ],
          selected: false,
        },
        {
          id: 2,
          title: 'analysis_type.offensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-white.svg',
          ],
          selected: false,
        },
        {
          id: 3,
          title: 'analysis_type.defensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-white.svg',
          ],
          selected: false,
        },
      ],
    };
  },
  created() {
    this.showModal = false;
  },
  mounted() {
    this.changeSection(this.value);
    this.showModal = false;
  },
  computed: {
    sectionsIds() {
      return this.sections.map(i => i.id);
    },
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    changeSection(sectionId) {
      if (this.sectionsIds.includes(sectionId)) {
        this.sections.forEach(e => (e.selected = false));
        const section = this.sections.find(s => s.id === sectionId);
        if (section) {
          section.selected = true;
          return true;
        }
      }
      return false;
    },
    onChangeSection(id) {
      this.section = id;
      let result = this.changeSection(id);
      if (result) this.$emit('input', id);
    },
  },
  watch: {
    value(newId) {
      this.changeSection(newId);
    },
  },
  mixins: [playerHeaderMixin],
};
</script>

<style scoped lang="css">
.headerfigma .active {
  background-color: #23b0ff !important;
}
.headerfigma .avenirnextltpro-demi-normal-white-6px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-s);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-demi-normal-white-10px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-light-white-10px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-light);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 300;
}

.headerfigma .avenirnextltpro-medium-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 500;
}

.headerfigma .avenirnextltpro-demi-normal-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-bold-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 700;
}

.headerfigma .avenirnextltpro-demi-normal-white-18px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-demi-normal-white-11-6px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-l);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-bold-white-16px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xl);
  font-style: normal;
  font-weight: 700;
}

.headerfigma .avenirnextltpro-light-white-18px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-light);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 300;
}

.headerfigma .avenirnextltpro-medium-big-stone-19-4px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: var(--font-size-xxxl);
  font-style: normal;
  font-weight: 500;
}

.headerfigma .avenirnextltpro-demi-normal-big-stone-19-4px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxxl);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .screen a {
  display: contents;
  text-decoration: none;
}

.headerfigma .valign-text-middle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  white-space: pre-line;
  text-align: left;
}

.headerfigma * {
  box-sizing: border-box;
}
.headerfigma .header-breadcrumbs-mobile-320 {
  align-items: center;
  border: 1px none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 100%;
  position: relative;
}

.headerfigma .header-1 {
  align-items: center;
  align-self: stretch;
  background: linear-gradient(
    180deg,
    rgb(6.85, 91.11, 137.06) 0%,
    rgba(1.63, 68.84, 105.5, 1) 51.8%,
    rgba(1.42, 14.25, 21.25, 1) 100%
  );
  background-color: transparent;
  border-radius: 8.2px;
  display: flex;
  gap: 4.82px;
  height: auto;
  mix-blend-mode: normal;
  padding: 7.72px 12px 6.75px;
  position: relative;
}

.headerfigma .header_container-1 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 11px;
  position: relative;
}

.headerfigma .player_data-1 {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 10.61px;
  position: relative;
}

.headerfigma .info-1 {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4.82px;
  height: 47.2px;
  justify-content: center;
  padding: 2px 0px 0px;
  position: relative;
}

.headerfigma .info_container-1 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  margin-top: 5px;
  flex: 1;
  flex-direction: column;
  gap: 2.2px;
  position: relative;
}

.headerfigma .container_info-1 {
  align-items: center;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.headerfigma .nationality-age-3 {
  align-items: center;
  display: flex;
  gap: 5.79px;
  position: relative;
  width: fit-content;
}

.headerfigma .country-flag-3 {
  height: 10px;
  max-width: 10px;
  object-fit: cover;
  position: relative;
  border-radius: 10px;
}

.headerfigma .nationality-age-item-3 {
  letter-spacing: -0.1px;
  line-height: 7.7px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .btn_player_info {
  align-items: center;
  background-color: var(--dodger-blue);
  border-radius: 5.3px;
  display: flex;
  flex-direction: column;
  font-family: 'Avenir-Demi';
  gap: 7px;
  justify-content: center;
  padding: 4px 12px;
  position: relative;
  width: fit-content;
}

.headerfigma .player-info {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: 9px;
  font-weight: 400;
  letter-spacing: -0.27px;
  line-height: 10px;
  margin-top: -0.48px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .header_info_menu-1 {
  align-items: center;
  align-self: stretch;
  border-radius: 5.79px;
  display: flex;
  gap: 6px;
  justify-content: center;
  position: relative;
}

.headerfigma .btn-1 {
  align-items: center;
  align-content: center;
  border-radius: 5.3px;
  display: flex;
  font-family: 'Avenir-Demi';
  flex: 1;
  font-size: 8px;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  padding: 6.5px 0px;
  position: relative;
  box-shadow: 0 0.5px 2.4px 0 rgba(27, 45, 63, 0.14);
  border: solid 0.5px #23b0ff;
}
@media screen and (max-width: 420px) {
  .headerfigma .btn-1 {
    padding: 6px 0px;
    padding-top: 8px;
    font-size: 7px;
  }
}
@media screen and (max-width: 340px) {
  .headerfigma .btn-1 {
    font-size: 6px;
    padding: 5px 0px;
    padding-top: 7px;
  }
}
.headerfigma .btn-1:hover {
  background-color: #23b0ff;
  cursor: pointer;
}

.headerfigma .radiografa-1,
.headerfigma .defensivo-1 {
  letter-spacing: -0.18px;
  line-height: 4px;
  margin-top: -0.48px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}
</style>
